module.exports = __webpack_public_path__ + "c_static/img/Account-authentication_img_gift_default@2x.cab0971.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/Account-authentication_img_gift_default@2x.png
// module id = ep0i
// module chunks = 33